import { c as _c } from "react/compiler-runtime";
import { Article } from 'schema-dts';
import { JsonLd } from '@sola/ark-skippy/atoms/jsonLd/jsonLd.tsx';
import { ArticleTemplate } from '@sola/ark-skippy/templates/article/article-template.tsx';
import { buildArticleJsonLd } from '@sola/ark-skippy/utils/schema-utils.ts';
import { LOCALES_CODES } from '@sola/contentful-model/lib/types.ts';
import { ArticleResponseDto } from '@sola/schema/lib/contentful.ts';
import { extractArgsArticle } from '../logic.tsx';
export const RenderArticle = t0 => {
  const $ = _c(21);
  const {
    article,
    path,
    experiments
  } = t0;
  let T0;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== article || $[1] !== path) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      props = extractArgsArticle(article);
      if (!props) {
        t4 = undefined;
        break bb0;
      }
      T0 = JsonLd;
      t1 = "https://schema.org";
      t2 = "Article";
      t3 = buildArticleJsonLd(props, path);
    }
    $[0] = article;
    $[1] = path;
    $[2] = T0;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    T0 = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t5 = {
      "@context": t1,
      "@type": t2,
      ...t3
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== T0 || $[13] !== t5) {
    t6 = <T0 item={t5} />;
    $[12] = T0;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== experiments || $[16] !== props) {
    t7 = <ArticleTemplate article={props} experiments={experiments} />;
    $[15] = experiments;
    $[16] = props;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};